const getRouteParams = ({ params = {}, path = '' }) => {
  const country = path.split('/')[1];

  return { ...params, country };
};

export default getRouteParams;
